"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.render = exports.setOpen = exports.get = void 0;
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiLoadShip_sidecar_1 = require("@voyage/ui/voyageUiLoadShip-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {});
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = gb.width - 500;
    var y = 20 + 40;
    var b = voyageUiGButtons_sidecar_1.voyageUiGButtons.create('New', x, y, function () {
        var name = (prompt('Name') || '').trim();
        if (name) {
            //goatGameMode_freeBuild.setFilename(name)
        }
    });
    obj.buttons.push(b);
    x += 120;
    b = voyageUiGButtons_sidecar_1.voyageUiGButtons.create('Load', x, y, function () {
        voyageUiLoadShip_sidecar_1.voyageUiLoadShip.setOpen(true);
    });
    obj.buttons.push(b);
    x += 120;
    return obj;
};
var setOpen = function (isOpen) {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = gb.width - 500;
    var y = 20;
    var w = 500;
    var h = 300;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        var t = voyageUiCanvas_sidecar_1.voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3);
        stevieTexts2_sidecar_1.stevieTexts2.setWrapWidth(t, w - 60);
        y += 20;
        return t;
    };
    var addSpacer = function () {
        y += 30;
    };
    addText('Editor - ' + voyageShipSaver_sidecar_1.voyageShipSaver.getLastFilename());
    // addText('Add new / load button')
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
exports.render = render;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        exports.render();
    }
};
exports.update = update;
